import { FcmToken } from '../../app/components/Native.tsx';
import { EmailSuppression } from '../models/EmailSuppression.ts';

export interface OperatorLoginData {
    organizationLoginId: string;
    operatorLoginId: number | null;
    username: string;
    mandantId: number;
    mandantName: string;
    firstname: string;
    lastname: string;
    email: string;
    description: string | null;
    telnr: string | null;
    permissions: Permissions;
    isAdmin: boolean;
    softAnonymizeCheckinPublicPermitAfterDays: number;
    maxSoftAnonymizeCheckinPublicPermitAfterDays: number;
    allowedPermitTypes: number[];
    allowedProductTypes: number[];
    allowedZones: number[];
    allowedRecodeConditions: string[];
    allowedParkingaboRoles: string[];
    fcmToken: FcmToken | null;
    otpEnabled: boolean;
    role: OperatorLoginRole;
    deletionDate: string | null;
    emailSuppression: EmailSuppression | null;
}

export enum OperatorLoginRole {
    ADMIN = 'ADMIN',
    SUPER_USER = 'SUPER_USER',
    USER = 'USER',
}

export interface Permissions {
    operatorAppActive: boolean;
    enforcementAppActive: boolean;
    parkingpayModule: boolean;
    taxomexModule: boolean;
    transactions: boolean;
    permitsRead: boolean;
    permitsWrite: boolean;
    activityStatement: boolean;
    whitelistCreate: boolean;
    whitelistDelete: boolean;
    userPermissionEdit: boolean;
    enforcementLog: boolean;
    syncApp: boolean;
    usbStickEdit: boolean;
    parkingMeterEdit: boolean;
    parkingMeterAlerts: boolean;
    refundParkTransactions: boolean;
    refundPermits: boolean;
    quotasWrite: boolean;
    parkingaboInitialBalanceCreate: boolean;
    cloudConnectorOffstreetDevicesView: boolean;
    cloudConnectorRecodeTicket: boolean;
    cloudConnectorAutoRecode: boolean;
    cloudConnectorAlerts: boolean;
    cloudConnectorReportingAccess: boolean;
    masterDataAndStatistics: boolean;
    parkingaboUserEdit: boolean;
    eventsRead: boolean;
    eventsWrite: boolean;
}
